export function getWordCount(text: string) {
    if (!text) {
        return 0;
    }
    return text?.replace(/\n/g, " ")?.trim()?.split(/[ ]+/)?.length
}